<template>
  <div class="block">
    <div class="header">
      <h4>
        <span class="required">*</span>
        Selecciona la velocidad de marcado
      </h4>
    </div>

    <div class="block block--light info">
      <InfoCircleOutlined class="icon" />
      <span class="info--text" action="Cerrar">
        Controla la velocidad de discado (llamada) que usará el sistema en esta nueva estrategia. 
        Durante la ejecución, solo podrás editar la velocidad de marcado si pausas la estrategia.
      </span>
    </div>

    <!-- Opciones -->
    <a-radio-group
      v-model:value="formState.speed"
      class="options"
    >
      <a-radio :value="StrategySpeed.Low">{{ StrategySpeedText[StrategySpeed.Low] }}</a-radio>
      <a-radio :value="StrategySpeed.Medium">{{ StrategySpeedText[StrategySpeed.Medium] }}</a-radio>
      <a-radio :value="StrategySpeed.High">{{ StrategySpeedText[StrategySpeed.High] }}</a-radio>
    </a-radio-group>

    <a-alert
      v-if="alertMessage"
      :message="alertMessage"
      type="warning"
      show-icon
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { watch } from "vue";
import { StrategySpeed, StrategySpeedDescription, StrategySpeedText } from "../../utils/modalStrategy";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:value"]);

const formState = ref({
  speed: props.value, // inicializamos con el valor recibido
});

// Sincronizamos formState.speed con el v-model
watch(
  () => formState.value.speed,
  (newValue: number) => {
    emit("update:value", newValue);
  }
);

// Mensaje dinámico según la opción seleccionada
const alertMessage = computed(() => {
  return StrategySpeedDescription[formState.value.speed as StrategySpeed] || "";
});
</script>

<style lang="sass" scoped>
.block
  padding: 16px 12px 20px 12px
  margin: 12px 0
  border: 1px solid #dcdcdc
  border-radius: 8px
  // background: #f8faff
  &--light
    border: 1px solid #dcdcdc
    color: $gray-7
    padding: 8px 12px
    margin: 4px 0 12px 0
    background-color: rgba(0, 0, 0, 0.02)

.header
  margin-bottom: 12px

.options
  display: flex
  gap: 24px
  margin: 12px 0

.option
  display: flex
  align-items: center
  gap: 6px
  font-size: 14px
  cursor: pointer

  input[type="radio"]
    accent-color: #1677ff
    cursor: pointer

.alert
  display: flex
  align-items: center
  padding: 10px 14px
  border-radius: 6px
  font-size: 13px
  margin-top: 10px
  background: #fff8e6
  border: 1px solid #ffe58f
  color: #ad8b00

.icon
  margin-right: 6px

.info
  display: flex

  &--text
    font-size: 12px

.required
  color: $red-7
  margin-right: 2px
</style>
